import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, Button } from '@sib/ui';
import { X } from '@sib/ui/icons';
import { useAskAiUrl } from './AskAiModal.utils';

interface AskAiModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const AskAiModal = ({ isOpen, onClose }: AskAiModalProps) => {
  const { t } = useTranslation();
  const { isAiEnabled, askAiUrl } = useAskAiUrl();

  if (!isAiEnabled || !askAiUrl) {
    return null;
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="h-[90vh] max-w-[90vw]">
        <div className="absolute top-4 right-4 z-10">
          <Button onClick={onClose} variant="ghost" size="sm">
            <X className="size-4" />
          </Button>
        </div>
        <iframe
          src={askAiUrl}
          className="h-full w-full rounded-lg border-0"
          title={t('askSpendBrain')}
          allow="clipboard-read; clipboard-write; microphone"
        />
      </DialogContent>
    </Dialog>
  );
};
